import type { PolicyFilterValues } from '../component/PolicyPageFilter/PolicyPageFilter';

export const agentPolicyKeys = {
  all: ['agent'] as const,
  policyList: (filters?: PolicyFilterValues) =>
    [...agentPolicyKeys.all, 'policyList', filters] as const,
  policyById: (policyId: string) =>
    [...agentPolicyKeys.all, policyId, 'policyById'] as const,
  filterOptions: (target: string, searchQuery: string) =>
    [...agentPolicyKeys.all, 'filterOptions', target, searchQuery] as const,
  identityList: (params?: { searchText?: string; filters?: unknown[] }) =>
    [...agentPolicyKeys.all, 'identityList', params] as const,
};
